import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 20l14 0","key":"svg-0"}],["path",{"d":"M5 17h5v-.3a7 7 0 1 1 4 0v.3h5","key":"svg-1"}]]

/**
 * IconZodiacLibra
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItem9kaWFjLWxpYnJhIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik01IDIwbDE0IDAiIC8+CiAgPHBhdGggZD0iTTUgMTdoNXYtLjNhNyA3IDAgMSAxIDQgMHYuM2g1IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/zodiac-libra
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconZodiacLibra = createReactComponent('outline', 'zodiac-libra', 'ZodiacLibra', __iconNode);

export default IconZodiacLibra;